"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _omit = _interopRequireDefault(require("lodash/omit"));

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    link: {
      color: theme.palette.primary.main,
      cursor: 'pointer'
    }
  };
};

var CustomTypography = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CustomTypography, _PureComponent);

  function CustomTypography() {
    (0, _classCallCheck2["default"])(this, CustomTypography);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CustomTypography).apply(this, arguments));
  }

  (0, _createClass2["default"])(CustomTypography, [{
    key: "render",
    value: function render() {
      var customStyling = !(0, _isEmpty["default"])(this.props.style) ? _objectSpread({}, this.props.style) : {};
      var variant = this.props.variant;
      var className = this.props.className;

      if ((0, _toLower["default"])(variant) === 'link1') {
        variant = 'body2';
        customStyling.textDecoration = customStyling.textDecoration || 'underline';
        className += ' ' + this.props.classes.link;
      } else if ((0, _toLower["default"])(variant) === 'link2') {
        variant = 'body1';
        customStyling.textDecoration = customStyling.textDecoration || 'underline';
        className += ' ' + this.props.classes.link;
      } else if ((0, _toLower["default"])(variant) === 'label') {
        variant = 'body1';
        customStyling.fontSize = customStyling.fontSize || '12px';
      }

      return _react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
        style: customStyling,
        className: className,
        variant: variant,
        classes: _objectSpread({}, (0, _omit["default"])(this.props.classes, 'link'))
      }, (0, _omit["default"])(this.props, 'variant', 'style', 'className', 'classes')));
    }
  }]);
  return CustomTypography;
}(_react.PureComponent);

CustomTypography.propTypes = {
  variant: _propTypes["default"].oneOf([// default material-ui
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit', // our custom
  'link1', 'link2', 'label']).isRequired,
  classes: _propTypes["default"].object,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string
};
CustomTypography.defaultProps = {
  style: {},
  className: '',
  variant: 'body1'
};

var _default = (0, _styles.withStyles)(styles)(CustomTypography);

exports["default"] = _default;